import { OrderRow } from '../../../BookingsCalendarTypes';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import Box from '@mui/material/Box';

export type MainProductsLabels = {
    title: string;
};

type MainProductsProps = {
    products: OrderRow[];
    labels: MainProductsLabels;
};

export function MainProducts({ products, labels }: MainProductsProps) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Typography
                vaeriant="h2"
                sx={(theme: any) => {
                    return {
                        color: theme.palette.grey[600],
                        fontSize: '16px',
                        textDecoration: 'underline'
                    };
                }}
            >
                {labels.title}:
            </Typography>
            {products.map((product) => (
                <Typography
                    key={product.orderRowId}
                    variant="h3"
                    sx={(theme: any) => {
                        return { color: theme.palette.grey[600], fontSize: '18px' };
                    }}
                >
                    {product.productOverrideName} ({product.productOriginalName})
                </Typography>
            ))}
        </Box>
    );
}
